import React, { Component } from 'react';
import AssessmentHistory from './AssessmentHistory';
import AssessmentTreatment from './AssessmentTreatment';
import { formatData, AssessmentInnerContainer, valueThenSubHeaderSection, valueThenSubTextDivs } from './examUtils';
import './Exam.css'

class BiomechanicalExam extends Component {
	state = {}

	render() { 

		const formattedExam = (formatData(this.props.data.exam))

		const Exam = formattedExam || {};
		const { 'NWB Range of Motion': NWBRangeOfMotion, 'NWB Observations': NWBObservations, 'WB Range of Motion': WBRangeOfMotion, Gait } = Exam || {};
		const { 'Clinical Impression': ClinicalImpression } = Gait || {};

		const orderedRearfootForefootKeys = ['Normal', 'Flexible Forefoot Valgus', 'Rigid Forefoot Valgus', 'Forefoot Equinus', 'Forefoot Supinatus', 
			'Forefoot Varus', 'Rearfoot Valgus', 'Rearfoot Varus', 'Plantar Flexed 1st Ray']
		const orderedFatPadAtrophyKeys = ['Heel', 'Forefoot']
		const orderedVaricosityKeys = ['Foot', 'Ankle', 'Leg', 'Comments']
		const orderedEdemaKeys = ['Foot', 'Ankle', 'Leg', 'Comments']
		const orderedLegPositioningKeys = ['Normal', 'Genu Valgum', 'Genu Varum', 'Recurvatum', 'Tibial Varum']

		const comparisonValues = (header, data) => (
			data && (
				<React.Fragment>
					<h3 className="Exam__details-sub-header">{header}:</h3>
					{data.Right && (
						<div className='Exam__details-sub-text'>
							Right: {data.Right}
							{data.Comparison && ` ${data.Comparison}`}
						</div>
					)}
					{data.Left && <div className='Exam__details-sub-text'>Left: {data.Left}</div>}
				</React.Fragment>
			)
		)

		if (Object.keys(formattedExam).filter(key => key !== 'Updated At' && key !== 'Role').length === 0) {
			return (
				<div className="Exam">
					{/* HISTORY */}
					<AssessmentHistory data={this.props.data.history} />

					<div className="Exam__details-container">
						<div className="Exam__details-container-header">
							<h2>Biomechanical Exam</h2>
						</div>
						<div className="Exam__details">
							<div className="Exam__details-not-found">No Exam Data Found</div>
						</div>
					</div>

					{/* TREATMENT */}
					<AssessmentTreatment data={this.props.data.treatment} />
				</div>
			)
		}

		return (
			<div className="Exam">
				{/* HISTORY */}
				<AssessmentHistory data={this.props.data.history} />

				{/* BIOMECHANICAL EXAM */}
				<div className="Exam__details-container">
					<div className="Exam__details-container-header">
						<h2>Biomechanical Exam</h2>
					</div>
					{NWBRangeOfMotion && <AssessmentInnerContainer header='NWB Range of Motion'>
						{comparisonValues('Subtalar Inversion', NWBRangeOfMotion['Subtalar Inversion'])}
						{comparisonValues('Subtalar Eversion', NWBRangeOfMotion['Subtalar Eversion'])}
						{comparisonValues('Ankle Dorsiflexion', NWBRangeOfMotion['Ankle Dorsiflexion'])}
						{comparisonValues('TMT Inversion', NWBRangeOfMotion['TMT Inversion'])}
						{comparisonValues('TMT Eversion', NWBRangeOfMotion['TMT Eversion'])}
						{comparisonValues('1st Ray', NWBRangeOfMotion['First Ray'])}
						{comparisonValues('1st MTPJ', NWBRangeOfMotion['First MTP Joint'])}
						{NWBRangeOfMotion['Rearfoot to Forefoot Relationship'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Rearfoot to Forefoot Relationship:</h3>
								{orderedRearfootForefootKeys.map((key, i) => (
									NWBRangeOfMotion['Rearfoot to Forefoot Relationship'][key] && (
										<React.Fragment key={i}>
											{valueThenSubTextDivs({value: NWBRangeOfMotion['Rearfoot to Forefoot Relationship'][key], label: key})}
										</React.Fragment>
									)
								))}
							</React.Fragment>
						)}
						{comparisonValues('Transverse Arch', NWBRangeOfMotion['Transverse Arch'])}
						{NWBRangeOfMotion['Other Range of Motion Comments'] && (
							<React.Fragment>
								{valueThenSubHeaderSection('Other Range of Motion Comments', NWBRangeOfMotion['Other Range of Motion Comments'])}
							</React.Fragment>
						)}
						{NWBRangeOfMotion['Orthopaedic Tests Comments'] && (
							<React.Fragment>
								{valueThenSubHeaderSection('Orthopaedic Tests Comments', NWBRangeOfMotion['Orthopaedic Tests Comments'])}
							</React.Fragment>
						)}
						{NWBRangeOfMotion.Tenderness && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Tenderness:</h3>
								{NWBRangeOfMotion.Tenderness.Right && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Right</div>
										{valueThenSubTextDivs({value: NWBRangeOfMotion.Tenderness.Right.Values})}
										{valueThenSubTextDivs({value: NWBRangeOfMotion.Tenderness.Right.Comments, label: 'Comments'})}
									</div>
								)}
								{NWBRangeOfMotion.Tenderness.Left && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Left</div>
										{valueThenSubTextDivs({value: NWBRangeOfMotion.Tenderness.Left.Values})}
										{valueThenSubTextDivs({value: NWBRangeOfMotion.Tenderness.Left.Comments, label: 'Comments'})}
									</div>
								)}
							</React.Fragment>
						)}
					</AssessmentInnerContainer>}
					{NWBObservations && <AssessmentInnerContainer header='NWB Observations'>
						{valueThenSubHeaderSection('Calluses, Corns and Ulcerations', NWBObservations['Calluses, Corns and Ulcerations'])}
						{valueThenSubHeaderSection('Hallux Abducto Valgus', NWBObservations['Hallux Abducto Valgus'])}
						{NWBObservations['Fat Pad Atrophy'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Fat Pad Atrophy:</h3>
								{orderedFatPadAtrophyKeys.map((key, i) => (
									NWBObservations['Fat Pad Atrophy'][key] && (
										<React.Fragment key={i}>
											{valueThenSubTextDivs({value: NWBObservations['Fat Pad Atrophy'][key], label: key})}
										</React.Fragment>
									)
								))}
							</React.Fragment>
						)}
						{NWBObservations.Deformities && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Deformities:</h3>
								{NWBObservations.Deformities.Right && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Right</div>
										{valueThenSubTextDivs({value: NWBObservations.Deformities.Right.Values})}
										{valueThenSubTextDivs({value: NWBObservations.Deformities.Right.Comments, label: 'Comments'})}
									</div>
								)}
								{NWBObservations.Deformities.Left && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Left</div>
										{valueThenSubTextDivs({value: NWBObservations.Deformities.Left.Values})}
										{valueThenSubTextDivs({value: NWBObservations.Deformities.Left.Comments, label: 'Comments'})}
									</div>
								)}
							</React.Fragment>
						)}
						{NWBObservations.Varicosity && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Varicosity:</h3>
								{orderedVaricosityKeys.map((key, i) => (
									NWBObservations.Varicosity[key] && (
										<div key={i} className="Exam__details-sub-text-section">
											<div className="Exam__details-sub-text">{key}</div>
											{valueThenSubTextDivs({value: NWBObservations.Varicosity[key]})}
										</div>
									)
								))}
							</React.Fragment>
						)}
						{NWBObservations.Edema && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Edema:</h3>
								{orderedEdemaKeys.map((key, i) => (
									NWBObservations.Edema[key] && (
										<div key={i} className="Exam__details-sub-text-section">
											<div className="Exam__details-sub-text">{key}</div>
											{valueThenSubTextDivs({value: NWBObservations.Edema[key]})}
										</div>
									)
								))}
							</React.Fragment>
						)}
						{NWBObservations['Orthopaedic Tests'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Orthopaedic Tests:</h3>
								<div className="Exam__details-sub-text">
									{valueThenSubTextDivs({value: NWBObservations['Orthopaedic Tests'].Values})}
									{valueThenSubTextDivs({value: NWBObservations['Orthopaedic Tests'].Comments, label: 'Comments'})}
								</div>
							</React.Fragment>
						)}
						{valueThenSubHeaderSection('Other Observations', NWBObservations['Other Observations'])}
					</AssessmentInnerContainer>}
					{WBRangeOfMotion && <AssessmentInnerContainer header='WB Range of Motion'>
						{WBRangeOfMotion['Medial Longitudinal Arch'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Medial Longitudinal Arch:</h3>
								<div className = "Exam__details-sub-text-section">
									{WBRangeOfMotion['Medial Longitudinal Arch'].Right && (
										<div className='Exam__details-sub-text'>
												Right: {WBRangeOfMotion['Medial Longitudinal Arch'].Right}
											{WBRangeOfMotion['Medial Longitudinal Arch'].Comparison && ` ${WBRangeOfMotion['Medial Longitudinal Arch'].Comparison}`}
										</div>
									)}
									{WBRangeOfMotion['Medial Longitudinal Arch'].Left && <div className='Exam__details-sub-text'>Left: {WBRangeOfMotion['Medial Longitudinal Arch'].Left}</div>}
								</div>
								<div className = "Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: WBRangeOfMotion['Medial Longitudinal Arch Flexibility'], label: 'Flexibility'})}
								</div>
							</React.Fragment>
						)}
						{WBRangeOfMotion['Leg Positioning'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Leg Positioning:</h3>
								{orderedLegPositioningKeys.map((key, i) => (
									WBRangeOfMotion['Leg Positioning'][key] && (
										<React.Fragment key={i}>
											{valueThenSubTextDivs({value: WBRangeOfMotion['Leg Positioning'][key], label: key})}
										</React.Fragment>
									)
								))}
							</React.Fragment>
						)}
						{WBRangeOfMotion['Calcaneal Positioning'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Calcaneal Positioning:</h3>
								{WBRangeOfMotion['Calcaneal Positioning'].LR && (
									<div className = "Exam__details-sub-text-section">
										{WBRangeOfMotion['Calcaneal Positioning'].LR.Right && (
											<div className='Exam__details-sub-text'>
												Right: {WBRangeOfMotion['Calcaneal Positioning'].LR.Right}
												{WBRangeOfMotion['Calcaneal Positioning'].LR.Comparison && ` ${WBRangeOfMotion['Calcaneal Positioning'].LR.Comparison}`}
											</div>
										)}
										{WBRangeOfMotion['Calcaneal Positioning'].LR.Left && <div className='Exam__details-sub-text'>Left: {WBRangeOfMotion['Calcaneal Positioning'].LR.Left}</div>}
									</div>
								)}
								<div className = "Exam__details-sub-text-section">
									<div className="Exam__details-sub-text">Flexibility</div>
									{valueThenSubTextDivs({value: WBRangeOfMotion['Calcaneal Positioning'].Flexibility})}
								</div>
							</React.Fragment>
						)}
						{valueThenSubHeaderSection('Skeletal Alignment', WBRangeOfMotion['Skeletal Alignment'])}
						{WBRangeOfMotion['Leg Length'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Leg Length:</h3>
								{valueThenSubTextDivs({value: WBRangeOfMotion['Leg Length'].Discrepancies, label: 'Discrepancies'})}
								{valueThenSubTextDivs({value: WBRangeOfMotion['Leg Length'].Other})}
								{WBRangeOfMotion['Leg Length'].Measurement && (
									<div className="Exam__details-sub-text">
										Measurement: {WBRangeOfMotion['Leg Length'].Measurement.Value}{WBRangeOfMotion['Leg Length'].Measurement.Unit}
									</div>
								)}
							</React.Fragment>
						)}
						{valueThenSubHeaderSection('Orthopaedic Tests', WBRangeOfMotion['Orthopaedic Tests'])}
						{valueThenSubHeaderSection('Other Observations', WBRangeOfMotion['Other Observations'])}
					</AssessmentInnerContainer>}
					{Gait && <AssessmentInnerContainer header='Gait'>
						{comparisonValues('Heel Strike', Gait['Heel Strike'])}
						{comparisonValues('Midstance', Gait['Midstance'])}
						{comparisonValues('Heel Lift', Gait['Heel Lift'])}
						{comparisonValues('Toe Off', Gait['Toe Off'])}
						{comparisonValues('Swing', Gait['Swing'])}
						{Gait['Types'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Type:</h3>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: Gait['Types']})}
									{valueThenSubTextDivs({value: Gait['Types Comments'], label: 'Comments'})}
								</div>
							</React.Fragment>
						)}
						{comparisonValues('Angle', Gait['Angle'])}
						{valueThenSubHeaderSection('Other Observations', Gait['Other Observations'])}
					</AssessmentInnerContainer>}
					{ClinicalImpression && <AssessmentInnerContainer header='Clinical Impression'>
						{ClinicalImpression.map((item, i) => (
							<React.Fragment key={i}>
								<div className="Exam__details-sub-text">{item}</div>
							</React.Fragment>
						))}
						
					</AssessmentInnerContainer>}
				</div>

				{/* TREATMENT */}
				<AssessmentTreatment data={this.props.data.treatment} />
			</div>
		);
	}
}
 
export default BiomechanicalExam;


// WEBPACK FOOTER //
// ./src/views/Assessment/BiomechanicalExam.js